import { render, staticRenderFns } from "./SocialMediaLinks.vue?vue&type=template&id=69cc89ae&"
import script from "./SocialMediaLinks.vue?vue&type=script&lang=js&"
export * from "./SocialMediaLinks.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaLinks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports